import Reflux from 'reflux';

export default Reflux.createActions([
  'paymentStarted',
  'paymentCompleted',
  'change',
  'genericError',
  'start',
  'cmoplete'
]);



// WEBPACK FOOTER //
// ./src/js/actions/Payment.js